import {
  getWorkspaceId,
  store,
  useUpdateThreadLastVisitTimeMutation,
} from '@zonofi/seller-rtk-store';
import { isEmpty } from 'lodash';

interface LastVisitRequest {
  channelId: string;
}

export const useUpdateLastVisitedTime = () => {
  const workspaceId = getWorkspaceId(store.getState());
  const [post] = useUpdateThreadLastVisitTimeMutation();

  const updateLastVisit = ({ channelId }: LastVisitRequest) => {
    if (!isEmpty(channelId)) {
      post({ channels: [channelId], sellerWorkspaceId: workspaceId });
    }
  };

  return { updateLastVisit };
};
